<template>
  <div :id="'pickup-and-delivery' + tripNumber" class="pickup-and-delivery">
    <div class="row m-0">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <Pickup
          :tripNumber="tripNumber"
          :zipCodes="zipArray"
          :cities="cityArray"
          v-model="pickupAndDelivery.from"
        />
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <Delivery
          :tripNumber="tripNumber"
          :zipCodes="zipArray"
          :cities="cityArray"
          v-model="pickupAndDelivery.to"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pickup from "./Pickup";
import Delivery from "./Delivery";
import { removePointerEvents } from "@/mixins/pickupAndDelivery/standardizers";
export default {
  name: "pickupAndDelivery",
  components: {
    Pickup,
    Delivery
  },
  props: {
    tripNumber: Number
  },
  data() {
    return {
      pickupAndDelivery: {
        from: {
          zip_from: null,
          city_from: null
        },
        to: {
          zip_to: null,
          city_to: null
        }
      },
      user: null,
      allowed: true,
      cityArray: [],
      zipArray: [],
      item: null,
      assignedUser: null,
      disableEmailResponse: true
    };
  },
  watch: {
    pickupAndDelivery() {
      return this.$emit("input", this.pickupAndDelivery);
    }
  },
  created() {
    this.haulInformation = this.$store.getters[
      "quotes/quote/showQuoteById"
    ].haul;
    for (let haul in this.haulInformation) {
      if (
        this.haulInformation[haul].zip_from != null &&
        !this.zipArray.includes(this.haulInformation[haul].zip_from)
      ) {
        this.zipArray.push(this.haulInformation[haul].zip_from);
      }
      if (!this.zipArray.includes(this.haulInformation[haul].zip_to)) {
        this.zipArray.push(this.haulInformation[haul].zip_to);
      }
      if (
        this.haulInformation[haul].city_from != null &&
        !this.cityArray.includes(this.haulInformation[haul].city_from)
      ) {
        this.cityArray.push(
          this.haulInformation[haul].city_from +
            "," +
            this.haulInformation[haul].state_from
        );
      }
      if (
        this.haulInformation[haul].city_to != null &&
        !this.cityArray.includes(this.haulInformation[haul].city_to)
      ) {
        this.cityArray.push(
          this.haulInformation[haul].city_to +
            "," +
            this.haulInformation[haul].state_to
        );
      }
    }
  },
  mounted() {
    let userAux = localStorage.getItem("charlie-username-otr");
    this.user = JSON.parse(userAux);
    this.handlerPickupAndDelivery();
    return this.$emit("input", this.pickupAndDelivery);
  },
  methods: {
    handlerPickupAndDelivery() {
      this.item = this.$store.getters["quotes/quote/showQuoteById"];
      let currentDepartment = JSON.parse(
        localStorage.getItem("current-department")
      );
      this.assignedUser =
        this.item.message.user == null ? null : this.item.message.user.username;
      if (
        (currentDepartment.department_id == 1 &&
          currentDepartment.rol_name == "superuser" &&
          this.assignedUser == null) ||
        this.user[0].user.username == this.assignedUser
      ) {
        this.disableEmailResponse = false;
      }
      let allowedRoutes = ["myQueue", "failed", "queue", "alerts"];
      if (!allowedRoutes.includes(this.$route.params.pathName)) {
        this.allowed = false;
      }
      if (this.allowed) {
        if (
          (currentDepartment.rol_name == "quoter" &&
            this.$route.params.pathName == "queue") ||
          this.disableEmailResponse ||
          this.item.message.validation_alert
        ) {
          removePointerEvents("pickup-and-delivery" + this.tripNumber);
        }
      } else {
        removePointerEvents("pickup-and-delivery" + this.tripNumber);
      }
    }
  }
};
</script>
